// Re-exports compile-time git SHA (see buildGitSha.generated.js).
export { default } from "./buildGitSha.generated.js";
